import type { SystemPageDto } from './system-pages.schema';
import z from 'zod';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { SystemPageDtoSchema } from './system-pages.schema';

export const systemPagesApi = {
  /**
   * Get system page by ID or alias
   * @param idOrAlias - ID or alias of the system page
   * @returns Promise<SystemPageDto> - system page data
   */
  async getSystemPageByIdOrAlias(idOrAlias: string) {
    const response = await httpClient.get<SystemPageDto>(
      ENDPOINTS.systemPages.idOrAlias(idOrAlias),
    );

    return validateWithZod(SystemPageDtoSchema, response);
  },

  async getListOfSystemPages() {
    const response = await httpClient.get<SystemPageDto[]>(
      ENDPOINTS.systemPages.all,
    );

    return z.array(SystemPageDtoSchema).parse(response);
  },
} as const;
